import Vue from 'vue'

import { getDateByTimeZone, formatDate } from '@/helpers/date'
import DateConverter from "@/helpers/DateConverter";

Vue.filter('getDateTimeZone', str => getDateByTimeZone(str))
Vue.filter('convertToLocalDate', DateConverter.convertDateToUserDateFormatted)
Vue.filter('formatDate', formatDate)
